import { getPrimaryTracker } from 'usage-tracker-container';
let _primaryTracker;
export default {
  track: (eventKey = '', eventProperties = {}) => {
    if (!_primaryTracker) {
      _primaryTracker = getPrimaryTracker();
    }
    return _primaryTracker.track(eventKey, eventProperties);
  }
};